import axios from 'axios';
import apisUrls from '../urls';

const getSingleSectionTitleApi = (filterObj) => {
  return axios.get(apisUrls.getSingleSectionTitle(filterObj));
};

export default getSingleSectionTitleApi;
